import { publishProfile } from "./profilePublication";

export const PRIVATE_CONTACT_PROFILE_FIELDS = Object.freeze([
  "role",
  "company",
  "organization",
  "industry",
  "school",
  "location",
  "email",
]);

/** Keep owner-entered contact details small, textual, and Firestore-safe. */
export function normalizePrivateContactProfile(profile) {
  return Object.fromEntries(
    PRIVATE_CONTACT_PROFILE_FIELDS
      .map((field) => [
        field,
        typeof profile?.[field] === "string" ? profile[field].trim() : "",
      ])
      .filter(([, value]) => value)
  );
}

/**
 * Build the profile shown to the owner. Their private contact-card details fill
 * gaps in a registered user's privacy-filtered public profile; public values
 * take precedence when the person has supplied them.
 */
export function contactProfileForEntry(entry) {
  const privateProfile = normalizePrivateContactProfile(entry?.private_profile);
  const publishedProfile = publishProfile(entry?.otherProfile || {}) || {};
  return { ...privateProfile, ...publishedProfile };
}
